import { AbstractControl } from '@angular/forms';
import { ValidationRegex } from '@app/origami-api/constants';

const pattern = ValidationRegex.url;

export function urlValidator(control: AbstractControl): { [key: string]: any } {
  const isUrl = pattern.test(control.value);
  return isUrl ? null : { notUrl: { value: control.value } };
}
